import React, { FC } from 'react';
import { styled } from 'linaria/lib/react';
import { FormatAliasPhone, formatPhoneNumber } from '@root/utils/formatPhoneNumber';
import { BurgerAvatar } from './BurgerAvatar';
interface PhoneProfileProps {
  phone: string;
}
export const PhoneProfile: FC<PhoneProfileProps> = ({
  phone
}) => <WrapperProfile>
    <BurgerAvatar />
    <WrapperPhoneProfile>{formatPhoneNumber(phone, FormatAliasPhone.SYMBOLS16)}</WrapperPhoneProfile>
  </WrapperProfile>;
const WrapperProfile = /*#__PURE__*/styled("div")({
  name: "WrapperProfile",
  class: "wu3l7n7"
});
const WrapperPhoneProfile = /*#__PURE__*/styled("div")({
  name: "WrapperPhoneProfile",
  class: "w1thqqcb"
});

require("./PhoneProfile.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./PhoneProfile.tsx");